import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { GetUserFilter } from '../models/security/get-user-filter';
import { GetUser } from '../models/security/get-user';
import { Paged } from '../models/shared/paged';
import { HttpUtil } from '../utils/http-util';
import { AddUser } from '../models/security/add-user';
import { AddUserPermission } from '../models/security/add-user-permission';
import { GetUserPermission } from '../models/security/get-user-permission';
import { GetUserPermissionFilter } from '../models/security/get-user-permission-filter';
import { AddUserRole } from '../models/security/add-user-role';
import { GetUserRoleFilter } from '../models/security/get-user-role-filter';
import { GetUserRole } from '../models/security/get-user-role';
import { AddUserResponse } from '../models/security/add-user-response';
import { environment } from '../../environments/environment';
import { UpdateUser } from '../models/security/update-user';
import { GetAddress } from '../models/security/register-request';
import { GetCandidate } from '../models/candidate/get-candidate';
import { GetUserCompany } from '../models/company/get-company';
import { GetAdmin } from '../models/admin/get-admin';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    private _http: HttpClient
  ) { }

  public addUser(user: AddUser): Observable<AddUserResponse> {
    return this._http.post<any>(`${environment.api.url}/User`, user);
  }

  public updateUser(user: UpdateUser): Observable<AddUserResponse> {
    return this._http.put<any>(`${environment.api.url}/User`, user);
  }

  public getUsers(filter: GetUserFilter): Observable<Paged<GetUser>> {
    return this._http.get<Paged<GetUser>>(`${environment.api.url}/User`, {
      params: HttpUtil.toHttpParams(filter)
    });
  }

  public addPermission(userId: number, userPermission: AddUserPermission): Observable<any> {
    return this._http.post<any>(`${environment.api.url}/User/${userId}/permission`, userPermission);
  }

  public getPermisions(userId: number, filter: GetUserPermissionFilter): Observable<Paged<GetUserPermission>> {
    return this._http.get<Paged<GetUserPermission>>(`${environment.api.url}/User/${userId}/permission`, {
      params: HttpUtil.toHttpParams(filter)
    });
  }

  public deletePermision(userId: number, permissionId: number): Observable<any> {
    return this._http.delete<any>(`${environment.api.url}/User/${userId}/permission/${permissionId}`);
  }

  public addRole(userId: number, userRole: AddUserRole): Observable<any> {
    return this._http.post<any>(`${environment.api.url}/User/${userId}/role`, userRole);
  }

  public getRoles(userId: number, filter: GetUserRoleFilter): Observable<Paged<GetUserRole>> {
    return this._http.get<Paged<GetUserRole>>(`${environment.api.url}/User/${userId}/role`, {
      params: HttpUtil.toHttpParams(filter)
    });
  }

  public deleteRole(userId: number, roleId: number): Observable<any> {
    return this._http.delete<any>(`${environment.api.url}/User/${userId}/role/${roleId}`);
  }

  public block(userId: number): Observable<any> {
    return this._http.post<any>(`${environment.api.url}/User/${userId}/block`, null);
  }

  public unblock(userId: number): Observable<any> {
    return this._http.post<any>(`${environment.api.url}/User/${userId}/unblock`, null);
  }

  public getAddresses(userId: number): Observable<GetAddress[]> {
    return this._http.get<GetAddress[]>(`${environment.api.url}/User/Addresses/${userId}`);
  }

  public getCandidate(userId: number): Observable<GetCandidate> {
    return this._http.get<GetCandidate>(`${environment.api.url}/User/Candidate/${userId}`);
  }

  public getAdmin(userId: number): Observable<GetAdmin> {
    return this._http.get<GetAdmin>(`${environment.api.url}/User/Admin/${userId}`);
  }

  public getUserCompany(userId: number): Observable<GetUserCompany> {
    return this._http.get<GetUserCompany>(`${environment.api.url}/User/Company/${userId}`);
  }
}
